// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"3f39c518","893":"eb11e2d9"}[chunkId] + ".chunk.js";
};